module.exports = __webpack_public_path__ + "media/images/front/products/extra/product_1-29c91cbed400281eef56c2e8cff59c27.jpg";